import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const rows = [{
  others: '15 a 60 días de espera',
  us: 'Entrega en 24 horas'
}, {
  others: 'Reuniones interminables',
  us: 'Todo por WhatsApp'
}, {
  others: 'Costos ocultos',
  us: 'Precio claro desde el inicio'
}, {
  others: 'Sin soporte después',
  us: 'Soporte incluido'
}];
export function Comparison() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-22" data-mp="1uwfgwuai7sw6">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-23" data-mp="1zw1uj4u8vb5i">
        <SectionHeading eyebrow="Comparación" title="Por qué elegir WEB24HS" description="La diferencia entre esperar meses y estar online mañana." data-id="element-24" data-mp="1zuh15ijo1y98" />

        <div className="mt-14 overflow-hidden rounded-3xl border border-black/5 shadow-soft" data-id="element-25" data-mp="28wgjce6f38dr">
          <table className="w-full border-collapse text-left" data-id="element-26" data-mp="9lfdng671eli">
            <caption className="sr-only" data-id="element-27" data-mp="eifl9vioypeq">Comparación entre otras agencias y WEB24HS</caption>
            <thead data-id="element-28" data-mp="1m0h1kpsb4m6z">
              <tr className="bg-[#FAFAFA]" data-id="element-29" data-mp="1m1qznez5tudm">
                <th scope="col" className="px-5 py-5 text-sm font-bold text-brand-ink/45 sm:px-8" data-id="element-30" data-mp="1m2tq5lsklut0">
                  Otros
                </th>
                <th scope="col" className="border-l border-black/5 bg-brand-yellowSoft px-5 py-5 text-sm font-extrabold text-brand-ink sm:px-8" data-id="element-31" data-mp="1d7m2yexchoq6">
                  WEB24HS
                </th>
              </tr>
            </thead>
            <tbody data-id="element-32" data-mp="24z1mu17ioxcp">
              {rows.map(row => <tr key={row.us} className="border-t border-black/5" data-id="element-33" data-mp="20xge8s20n58b">
                  <td className="px-5 py-5 align-middle sm:px-8" data-id="element-34" data-mp="20w5autchfzhq">
                    <span className="flex items-start gap-3 text-sm text-brand-ink/45 sm:text-base" data-id="element-35" data-mp="1vxbv0u9q3wee">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-36" data-mp="1qzabk88dxv2e" />
                      {row.others}
                    </span>
                  </td>
                  <td className="border-l border-black/5 px-5 py-5 align-middle sm:px-8" data-id="element-37" data-mp="fkdkytwjyxsx">
                    <span className="flex items-start gap-3 text-sm font-semibold text-brand-ink sm:text-base" data-id="element-38" data-mp="h1aoolfu1x2i">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-ink" aria-hidden="true" data-id="element-39" data-mp="lzu9ujmlr4tt" />
                      {row.us}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}